import { useEnableCollaborationMutation } from "@api/accounts";
import { trackContent } from "@editor/utils";
import { useAppDispatch } from "@store";
import { setDialogId } from "@store/global-slice";
import { toast } from "react-toastify";
import { Button, Icon } from "@/shared";

export const Wrapper = () => {
  const dispatch = useAppDispatch();
  const close = () => dispatch(setDialogId({ id: null }));
  const [enableCollaboration, { isLoading }] = useEnableCollaborationMutation();

  const handleEnableCollaboration = async () => {
    try {
      trackContent("click activate comments");
      await enableCollaboration({}).unwrap();
      trackContent("success activate comments");
      const url = new URL(window.location.href);
      if (url.search) url.search += "&comments";
      else url.search = "?comments";
      window.location.href = url.toString();
    } catch (error) {
      trackContent("failed activate comments", {
        "failure message":
          error && typeof error === "object" && "message" in error
            ? error.message
            : "Unknown error message",
      });
      toast.error("Failed to enable comments. Please try again later.");
    }
  };

  return (
    <div className="tw-relative">
      <div className="tw-w-[616px] tw-overflow-hidden tw-rounded-lg tw-bg-white tw-shadow-md">
        <div className="tw-relative tw-overflow-hidden tw-pt-[56.25%]">
          <span className="tw-absolute tw-inset-0 tw-left-0 tw-top-0 tw-animate-pulse-regular tw-bg-skeleton-gradient"></span>
          <video
            className="tw-absolute tw-inset-0 tw-object-cover"
            autoPlay
            loop
            muted
            playsInline
          >
            <source
              src="https://www.storydoc.com/assets/videos/collaboartion-activation.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div className="tw-flex tw-flex-col tw-items-center tw-py-10">
          <h2 className="tw-mb-2 tw-mt-0 tw-text-center tw-font-sans tw-text-[28px]/tight tw-font-bold tw-text-blue-base">
            Comments are here!
          </h2>
          <p className="tw-m-0 tw-text-center tw-font-sans tw-text-base tw-font-normal tw-text-blue-base">
            You can now write comments and attach them <br /> to any element of
            your story.
          </p>
          <div className="tw-mt-10 tw-flex tw-items-center tw-gap-4">
            <Button
              variant="secondary"
              size="large"
              title="Try later"
              className="tw-w-36"
              onClick={close}
            />
            <Button
              variant="primary"
              size="large"
              title="Use comments"
              className="tw-w-36"
              loading={isLoading}
              onClick={handleEnableCollaboration}
            />
          </div>
        </div>
      </div>
      <div
        className="tw-absolute -tw-right-4 tw-top-0 tw-flex tw-size-10 tw-translate-x-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-shadow-md tw-transition-opacity hover:tw-opacity-70"
        onClick={close}
      >
        <Icon icon="ri-close-fill" size={24} color="#88819F" />
      </div>
    </div>
  );
};
